import React from 'react';
import './ui.css';

/**
 * Label above, control below, help text under that.
 *
 * Pass `htmlFor` when the control is a single form element — the label then
 * becomes a real <label> and clicking it focuses the input. Leave it off for
 * a control made of several elements, such as a Segmented (a radio group
 * labelled by a <label> would activate its first option on any label click)
 * or a row of toggle chips; the label renders as plain text instead and the
 * control labels itself.
 *
 * `dimmed` is for a field that does not apply to the current selections —
 * target score on a set-ends match, say. The field stays in place at reduced
 * contrast rather than disappearing, so the form does not reflow under the
 * pointer as you change format or match type. Dimming is presentation only:
 * the caller still has to disable the control.
 */
function Field({ children, dimmed = false, help, htmlFor, label, style }) {
  const LabelTag = htmlFor ? 'label' : 'span';
  return (
    <div className={`gs-field${dimmed ? ' gs-field-dimmed' : ''}`} style={style}>
      {label && (
        <LabelTag className="gs-field-label" htmlFor={htmlFor || undefined}>
          {label}
        </LabelTag>
      )}
      {children}
      {help && <div className="gs-field-help">{help}</div>}
    </div>
  );
}

export default Field;
